import deferEditionModalParameters from '@atlassian/jira-relay/src/__generated__/src_DeferEditionModalQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type EntryPointParams = {
	cloudId: string;
	productKey: string;
};

const Fallback = () => null;

export const jiraDeferEditionModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(async () => {
		if (!__SERVER__) {
			return import(/* webpackChunkName: "async-jira-defer-edition-modal" */ './src/index').then(
				({ DeferEditionModalComponent }) => DeferEditionModalComponent,
			);
		}

		return Fallback;
	}),
	getPreloadProps: ({ cloudId, productKey }: EntryPointParams) => ({
		queries: {
			deferEditionModal: {
				parameters: deferEditionModalParameters,
				variables: { cloudId, productKey },
			},
		},
	}),
});
